import { Layer } from "@carbon/react";
import {
  TableToolbarFilter as SharedTableToolbarFilter,
  TableToolbarFilterProps,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export const TableToolbarFilter: FC<Omit<TableToolbarFilterProps, "languageTexts">> = (props) => {
  const t = useT();

  return (
    <Layer className="flex">
      <SharedTableToolbarFilter
        {...props}
        languageTexts={{
          apply: t("general.actions.apply"),
          reset: t("general.actions.reset"),
          popoverTitle: t("component.table.filter.popover.title"),
          cancel: t("general.actions.cancel"),
        }}
      />
    </Layer>
  );
};
